import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMagicWand2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMagicWand2"><Path fillRule="evenodd" clipRule="evenodd" d="M18.4982 1.93933L22.0588 5.49999L5.49816 22.0606L1.9375 18.5L18.4982 1.93933ZM15.3088 7.24999L16.7482 8.68933L19.9375 5.49999L18.4982 4.06065L15.3088 7.24999Z" fill="currentColor"/><Path d="M10 2L11 0L12 2L14 3L12 4L11 6L10 4L8 3L10 2Z" fill="currentColor"/><Path d="M19 13L20 11L21 13L23 14L21 15L20 17L19 15L17 14L19 13Z" fill="currentColor"/><Path d="M5 7L6 5L7 7L9 8L7 9L6 11L5 9L3 8L5 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMagicWand2;
